exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".bounceDetail{height:100%}.bounceDetail .title{display:inline-block;width:140px;text-align:right}.bounceDetail .detail{margin-left:20px;overflow:hidden}.bounceDetail .imgSpan{position:relative;top:-70px}.bounceDetail .panel{height:90px}.bounceDetail img{display:inline-block;width:150px;height:80px}.bounceDetail .contain{display:inline-block;padding:15px 10px;width:80%;height:135px;box-sizing:border-box;border:1px solid #999;overflow:scroll;vertical-align:middle}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader!./~/vue-loader/lib/style-rewriter.js?id=data-v-3ee7a885!./~/vue-loader/lib/selector.js?type=styles&index=0!./src/components/yunying/bounce/bounceDetail.vue
// module id = 501
// module chunks = 0